
import { Component, Vue, Prop } from "vue-property-decorator"
import { State } from "vuex-class"

import TextAreaToggleExpand from "@/components/Fields/TextAreaToggleExpand.vue"

import api from "@/services/api"
import { richTextHasText } from "@/scripts/richText"
import { CaseDetails } from "@/types"

@Component({
	components: {
		"text-area-expand": TextAreaToggleExpand
	}
})
export default class PostComment extends Vue {
	@Prop()
	public currentCase!: CaseDetails;

	@Prop({ type: Boolean, default: false })
	canCreateComments!: boolean;

	@State tenantEnabledFeatures!: { [key: string]: boolean }

	private comment: string = "";
	private postingComment = false

	private get canSubmitComment (): boolean {
		return this.canCreateComments &&
			!!this.currentCase?.id &&
			!this.postingComment &&
			this.hasText
	}

	private get hasText (): boolean {
		return this.tenantEnabledFeatures["richText"]
			? richTextHasText(this.comment)
			: /\S/.test(this.comment)
	}

	public async postComment () {
		if (!this.canSubmitComment) return

		this.postingComment = true

		try {
			const caseId = this.currentCase?.id
			if (!caseId) return

			const comment = this.comment.trim()
			await api.postComment(caseId,
				comment,
				null,
				!!this.tenantEnabledFeatures["richText"]
			)
			this.comment = ""
			this.$emit("commentAdded", comment)
		} finally {
			this.postingComment = false
		}
	}

	private get postCommentBoxStyle () {
		return {
			width: this.comment.length > 0 ? "46px" : "0",
			transition: "width 0.2s"
		}
	}
}
